import { useMemo } from "react";
import { Box, Flex, Text, VStack } from "@chakra-ui/react";
import { Span } from "src/components/base";
import { IFeedCardTradingMotiveBody } from "src/components/feed-card/types/content";
import { EnumFeedCardTradingMotiveType } from "src/components/feed-card/types/enums";
import { IconBuyingTheDip, IconFearOfMissingOut, IconJumpingTheShip, IconTakingProfits } from "src/components/icons";
import { useNumberFormatter } from "src/hooks/formatters/use-number-formatter";

export const FeedCardTradingMotive = ({ type, title, value, label }: IFeedCardTradingMotiveBody) => {
    const { formatPerformance } = useNumberFormatter();
    const backgroundColor =
        type === EnumFeedCardTradingMotiveType.FOMO || type === EnumFeedCardTradingMotiveType.BuyingTheDip ? "green.50" : "red.100";
    const valueColor = value > 0 ? "green.600" : "red.600";

    const TradingMotiveIcon = useMemo(() => {
        switch (type) {
            case EnumFeedCardTradingMotiveType.BuyingTheDip:
                return IconBuyingTheDip;
            case EnumFeedCardTradingMotiveType.FOMO:
                return IconFearOfMissingOut;
            case EnumFeedCardTradingMotiveType.TakingProfits:
                return IconTakingProfits;
            case EnumFeedCardTradingMotiveType.JumpingTheShip:
                return IconJumpingTheShip;
            default:
                return Box;
        }
    }, [type]);

    return (
        <VStack alignItems="left" spacing={2}>
            <Flex justifyContent="center" alignItems="center" w="100%" aspectRatio={16 / 9} backgroundColor={backgroundColor}>
                <TradingMotiveIcon w="50%" h="50%" />
            </Flex>
            <Box>
                <Text fontWeight="semibold" color="gray.500" fontSize="sm">
                    <Span color={valueColor}>{formatPerformance(value, 1)}</Span> {label}
                </Text>
                <Text fontSize="md" fontWeight="bold" mt={0.5}>
                    {title}
                </Text>
            </Box>
        </VStack>
    );
};
